var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import PropTypes from "prop-types";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import { FormattedCurrency, FormattedMessage, injectIntl } from "@irati/utils/lang";
import { Hr } from "@irati/ui/src/Layout";
import history from "@irati/utils/history";
import id from "@irati/utils/id";
import { rewardTracking } from "@irati-tracking/reward";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import { buildProductOptions } from "../../utils";
import ImportantInfo from "./ImportantInfo";
import TermsAndConditions from "./TermsAndConditions";
import { AvailableBalance, StyledCaption, RewardOptions, Button } from "./styled";
var Summary = /** @class */ (function (_super) {
    __extends(Summary, _super);
    function Summary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            options: [],
            selectedOption: null,
            clickDenominationEventTracked: false
        };
        _this.handleButtonClick = function () {
            var selectedOption = _this.state.selectedOption;
            var reward = _this.props.reward;
            var products = get(reward, "products.results");
            var selectedProduct = products.find(function (product) { return product.uuid === selectedOption; });
            rewardTracking.rewardsTabAddRewardStart(reward);
            history.push({
                pathname: "/reward/create",
                state: {
                    reward: reward,
                    product: selectedProduct
                }
            }, _this.context);
        };
        _this.handleButtonClickWithTracking = function () {
            rewardWalletTracking.clickRewardWithCredit();
            _this.handleButtonClick();
        };
        _this.handleSelectChangeWithTracking = function (value) {
            rewardWalletTracking.updateDenominationDropdown();
            _this.handleSelectChange(value);
        };
        _this.handleSelectChange = function (value) {
            _this.setState({ selectedOption: value });
        };
        _this.handleClickDenominationDropdown = function () {
            if (!_this.state.clickDenominationEventTracked) {
                _this.setState({ clickDenominationEventTracked: true });
                rewardWalletTracking.clickDenominationDropdown();
            }
        };
        return _this;
    }
    Summary.prototype.componentDidMount = function () {
        var _a = this.props, intl = _a.intl, reward = _a.reward;
        var options = buildProductOptions(reward, intl);
        var selectedOption = options[0].value;
        this.setState({ options: options, selectedOption: selectedOption });
    };
    Summary.prototype.render = function () {
        var _a = this.props, reward = _a.reward, onClickTermsAndConditions = _a.onClickTermsAndConditions;
        var _b = this.state, options = _b.options, selectedOption = _b.selectedOption;
        var idNamespace = id("reward-detail-summary", this.props);
        if (reward.isCredit) {
            return (React.createElement(React.Fragment, null,
                React.createElement(RewardWalletBalanceQuery, null, function (_a) {
                    var data = _a.data;
                    var _b = data.rewardWallet, availableBalance = _b.availableBalance, currency = _b.currency;
                    return (React.createElement(React.Fragment, null,
                        React.createElement(StyledCaption, { flush: true },
                            React.createElement(FormattedMessage, { id: "reward.detail.credit.availableBalance.title" })),
                        React.createElement(AvailableBalance, null,
                            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: availableBalance })),
                        React.createElement(StyledCaption, null,
                            React.createElement(FormattedMessage, { id: "reward.detail.credit.availableBalance.footer" }))));
                }),
                React.createElement(Hr, { small: true }),
                React.createElement("div", { onClick: this.handleClickDenominationDropdown },
                    React.createElement(RewardOptions, { id: id("select", idNamespace), label: "reward.detail.select.label", name: "product-id", options: options, onChange: this.handleSelectChangeWithTracking, isClearable: false, value: selectedOption })),
                React.createElement(Button, { primary: true, large: true, onClick: this.handleButtonClickWithTracking },
                    React.createElement(FormattedMessage, { id: "reward.detail.creditReward.label" }))));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ImportantInfo, { reward: reward }),
            React.createElement(TermsAndConditions, { reward: reward, onClick: onClickTermsAndConditions }),
            React.createElement(Hr, { small: true }),
            React.createElement(RewardOptions, { id: id("select", idNamespace), label: "reward.detail.select.label", name: "product-id", options: options, onChange: this.handleSelectChange, isClearable: false, value: selectedOption }),
            React.createElement(Button, { primary: true, large: true, onClick: this.handleButtonClick },
                React.createElement(FormattedMessage, { id: "reward.detail.btnReward.label" }))));
    };
    Summary.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return Summary;
}(Component));
export default withRouter(injectIntl(Summary));
